import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function TrustBadges() {
  return <section className="max-w-lg mx-auto px-4 pb-8" data-id="element-110">
      <div className="bg-soft-beige rounded-xl p-5" data-id="element-111">
        <div className="flex items-center gap-2 mb-3" data-id="element-112">
          <ShieldCheckIcon className="w-5 h-5 text-champagne-gold" data-id="element-113" />
          <h3 className="text-base font-semibold text-deep-cocoa" data-id="element-114">
            Tu pago está protegido
          </h3>
        </div>

        <p className="text-sm text-deep-cocoa/80 mb-4 leading-relaxed" data-id="element-115">
          Stripe procesa millones de pagos cada día. Nosotros no vemos ni
          guardamos tus datos de tarjeta. Todo está cifrado y protegido.
        </p>

        {/* Payment Method Badges */}
        <div className="flex items-center justify-center gap-3 pt-3 border-t border-deep-cocoa/10" data-id="element-116">
          <div className="flex items-center gap-2 px-3 py-1.5 bg-white rounded-lg shadow-sm" data-id="element-117">
            <svg className="w-8 h-5" viewBox="0 0 48 32" fill="none" data-id="element-118">
              <rect width="48" height="32" rx="4" fill="#1434CB" data-id="element-119" />
              <path d="M18.5 11L14 21h3.5l4.5-10h-3.5z" fill="white" data-id="element-120" />
              <path d="M29.5 11L25 21h3.5l4.5-10h-3.5z" fill="#FFA500" data-id="element-121" />
            </svg>
            <span className="text-xs font-medium text-deep-cocoa" data-id="element-122">Visa</span>
          </div>

          <div className="flex items-center gap-2 px-3 py-1.5 bg-white rounded-lg shadow-sm" data-id="element-123">
            <svg className="w-8 h-5" viewBox="0 0 48 32" fill="none" data-id="element-124">
              <circle cx="18" cy="16" r="10" fill="#EB001B" data-id="element-125" />
              <circle cx="30" cy="16" r="10" fill="#F79E1B" data-id="element-126" />
            </svg>
            <span className="text-xs font-medium text-deep-cocoa" data-id="element-127">
              Mastercard
            </span>
          </div>

          <div className="flex items-center gap-2 px-3 py-1.5 bg-white rounded-lg shadow-sm" data-id="element-128">
            <svg className="w-8 h-5" viewBox="0 0 48 32" fill="none" data-id="element-129">
              <rect width="48" height="32" rx="4" fill="#006FCF" data-id="element-130" />
              <text x="24" y="20" fontSize="10" fill="white" textAnchor="middle" fontWeight="bold" data-id="element-131">
                AMEX
              </text>
            </svg>
            <span className="text-xs font-medium text-deep-cocoa" data-id="element-132">Amex</span>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 mt-3 pt-3 border-t border-deep-cocoa/10" data-id="element-133">
          <svg className="w-12 h-5" viewBox="0 0 60 25" fill="none" data-id="element-134">
            <path d="M3 12.5C3 7.25 7.25 3 12.5 3h35C52.75 3 57 7.25 57 12.5S52.75 22 47.5 22h-35C7.25 22 3 17.75 3 12.5z" fill="#635BFF" data-id="element-135" />
            <text x="30" y="16" fontSize="8" fill="white" textAnchor="middle" fontWeight="bold" data-id="element-136">
              stripe
            </text>
          </svg>
          <span className="text-xs text-deep-cocoa/70" data-id="element-137">Procesador seguro</span>
        </div>
      </div>
    </section>;
}